import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const AgentmasterEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		agentcode: yup.string().required().label($t('agentcode')),
		agentname: yup.string().nullable().label($t('agentname')),
		joiningdate: yup.string().required().label($t('joiningdate')),
		formno: yup.string().nullable().label($t('formno')),
		branchcode: yup.string().nullable().label($t('branchcode')),
		empcode: yup.string().nullable().label($t('empcode')),
		accountnumber: yup.string().required().label($t('accountnumber')),
		rankid: yup.string().nullable().label($t('rankid')),
		position: yup.string().nullable().label($t('position')),
		introducercode: yup.string().nullable().label($t('introducercode')),
		introducername: yup.string().nullable().label($t('introducername')),
		introducerrank: yup.number().nullable().label($t('introducerrank')),
		regamount: yup.string().nullable().label($t('regamount')),
		guardianname: yup.string().nullable().label($t('guardianname')),
		address1: yup.string().nullable().label($t('address1')),
		address2: yup.string().nullable().label($t('address2')),
		phone: yup.string().nullable().label($t('phone')),
		pincode: yup.string().nullable().label($t('pincode')),
		gender: yup.string().nullable().label($t('gender')),
		dob: yup.string().nullable().label($t('dob')),
		age: yup.string().nullable().label($t('age')),
		bloodgroup: yup.string().nullable().label($t('bloodgroup')),
		education: yup.string().nullable().label($t('education')),
		nomineename: yup.string().nullable().label($t('nomineename')),
		relationid: yup.string().nullable().label($t('relationid')),
		nomineeage: yup.string().nullable().label($t('nomineeage')),
		nomineeremarks: yup.string().nullable().label($t('nomineeremarks')),
		pancard: yup.string().nullable().label($t('pancard')),
		bankname: yup.string().nullable().label($t('bankname')),
		bankacno: yup.string().nullable().label($t('bankacno')),
		passport: yup.string().nullable().label($t('passport')),
		dateadded: yup.string().nullable().label($t('dateadded')),
		addedbyfk: yup.string().nullable().label($t('addedbyfk')),
		datemodified: yup.string().nullable().label($t('datemodified')),
		lastuserfk: yup.string().nullable().label($t('lastuserfk'))
	});
	// form default values
	const formDefaultValues = {
		agentcode: '', 
		agentname: '', 
		joiningdate: new Date(), 
		formno: '', 
		branchcode: '', 
		empcode: '', 
		accountnumber: "(N'-", 
		rankid: '', 
		position: '', 
		introducercode: '', 
		introducername: '', 
		introducerrank: '', 
		regamount: '', 
		guardianname: '', 
		address1: '', 
		address2: '', 
		phone: '', 
		pincode: '', 
		gender: '', 
		dob: new Date(), 
		age: '', 
		bloodgroup: '', 
		education: '', 
		nomineename: '', 
		relationid: '', 
		nomineeage: '', 
		nomineeremarks: '', 
		pancard: '', 
		bankname: '', 
		bankacno: '', 
		passport: '', 
		dateadded: new Date(), 
		addedbyfk: '', 
		datemodified: new Date(), 
		lastuserfk: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/agentmaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="AgentmasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editAgentmaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('agentcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="agentcode"  onChange={formik.handleChange}  value={formik.values.agentcode}   label={$t('agentcode')} type="text" placeholder={$t('enterAgentcode')}        className={inputClassName(formik?.errors?.agentcode)} />
                                                <ErrorMessage name="agentcode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('agentname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="agentname"  onChange={formik.handleChange}  value={formik.values.agentname}   label={$t('agentname')} type="text" placeholder={$t('enterAgentname')}        className={inputClassName(formik?.errors?.agentname)} />
                                                <ErrorMessage name="agentname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('joiningdate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="joiningdate" value={formik.values.joiningdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.joiningdate)}        />
                                                <ErrorMessage name="joiningdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('formno')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="formno"  onChange={formik.handleChange}  value={formik.values.formno}   label={$t('formno')} type="text" placeholder={$t('enterFormno')}        className={inputClassName(formik?.errors?.formno)} />
                                                <ErrorMessage name="formno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('branchcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/branchcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={formik.handleChange} options={response} label={$t('branchcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                    <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountnumber')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountnumber"  onChange={formik.handleChange}  value={formik.values.accountnumber}   label={$t('accountnumber')} type="text" placeholder={$t('enterAccountnumber')}        className={inputClassName(formik?.errors?.accountnumber)} />
                                                <ErrorMessage name="accountnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('rankid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/rankid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="rankid"     optionLabel="label" optionValue="value" value={formik.values.rankid} onChange={formik.handleChange} options={response} label={$t('rankid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.rankid)}   />
                                                    <ErrorMessage name="rankid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('position')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="position"  onChange={formik.handleChange}  value={formik.values.position}   label={$t('position')} type="text" placeholder={$t('enterPosition')}        className={inputClassName(formik?.errors?.position)} />
                                                <ErrorMessage name="position" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('introducercode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="introducercode"  onChange={formik.handleChange}  value={formik.values.introducercode}   label={$t('introducercode')} type="text" placeholder={$t('enterIntroducercode')}        className={inputClassName(formik?.errors?.introducercode)} />
                                                <ErrorMessage name="introducercode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('introducername')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="introducername"  onChange={formik.handleChange}  value={formik.values.introducername}   label={$t('introducername')} type="text" placeholder={$t('enterIntroducername')}        className={inputClassName(formik?.errors?.introducername)} />
                                                <ErrorMessage name="introducername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('introducerrank')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="introducerrank"  onChange={formik.handleChange}  value={formik.values.introducerrank}   label={$t('introducerrank')} type="number" placeholder={$t('enterIntroducerrank')}  min={0}  step="any"    className={inputClassName(formik?.errors?.introducerrank)} />
                                                <ErrorMessage name="introducerrank" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('regamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="regamount"  onChange={formik.handleChange}  value={formik.values.regamount}   label={$t('regamount')} type="text" placeholder={$t('enterRegamount')}        className={inputClassName(formik?.errors?.regamount)} />
                                                <ErrorMessage name="regamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('guardianname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="guardianname"  onChange={formik.handleChange}  value={formik.values.guardianname}   label={$t('guardianname')} type="text" placeholder={$t('enterGuardianname')}        className={inputClassName(formik?.errors?.guardianname)} />
                                                <ErrorMessage name="guardianname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('address1')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address1"  onChange={formik.handleChange}  value={formik.values.address1}   label={$t('address1')} type="text" placeholder={$t('enterAddress1')}        className={inputClassName(formik?.errors?.address1)} />
                                                <ErrorMessage name="address1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('address2')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address2"  onChange={formik.handleChange}  value={formik.values.address2}   label={$t('address2')} type="text" placeholder={$t('enterAddress2')}        className={inputClassName(formik?.errors?.address2)} />
                                                <ErrorMessage name="address2" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('phone')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="phone"  onChange={formik.handleChange}  value={formik.values.phone}   label={$t('phone')} type="text" placeholder={$t('enterPhone')}        className={inputClassName(formik?.errors?.phone)} />
                                                <ErrorMessage name="phone" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pincode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pincode"  onChange={formik.handleChange}  value={formik.values.pincode}   label={$t('pincode')} type="text" placeholder={$t('enterPincode')}        className={inputClassName(formik?.errors?.pincode)} />
                                                <ErrorMessage name="pincode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('gender')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.gender.map((option) => {
                                                return (
                                                <div key={option.value} className="field-radiobutton">
                                                    <RadioButton inputId={option.value} name="gender" value={option.value} onChange={formik.handleChange}  checked={formik.values.gender === option.value} className={inputClassName(formik?.errors?.gender, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="gender" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dob')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dob" value={formik.values.dob} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.dob)}        />
                                                <ErrorMessage name="dob" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('age')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="age"  onChange={formik.handleChange}  value={formik.values.age}   label={$t('age')} type="text" placeholder={$t('enterAge')}        className={inputClassName(formik?.errors?.age)} />
                                                <ErrorMessage name="age" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bloodgroup')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bloodgroup"  onChange={formik.handleChange}  value={formik.values.bloodgroup}   label={$t('bloodgroup')} type="text" placeholder={$t('enterBloodgroup')}        className={inputClassName(formik?.errors?.bloodgroup)} />
                                                <ErrorMessage name="bloodgroup" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('education')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="education"  onChange={formik.handleChange}  value={formik.values.education}   label={$t('education')} type="text" placeholder={$t('enterEducation')}        className={inputClassName(formik?.errors?.education)} />
                                                <ErrorMessage name="education" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nomineename')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nomineename"  onChange={formik.handleChange}  value={formik.values.nomineename}   label={$t('nomineename')} type="text" placeholder={$t('enterNomineename')}        className={inputClassName(formik?.errors?.nomineename)} />
                                                <ErrorMessage name="nomineename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('relationid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/relationid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="relationid"     optionLabel="label" optionValue="value" value={formik.values.relationid} onChange={formik.handleChange} options={response} label={$t('relationid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.relationid)}   />
                                                    <ErrorMessage name="relationid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nomineeage')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nomineeage"  onChange={formik.handleChange}  value={formik.values.nomineeage}   label={$t('nomineeage')} type="text" placeholder={$t('enterNomineeage')}        className={inputClassName(formik?.errors?.nomineeage)} />
                                                <ErrorMessage name="nomineeage" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nomineeremarks')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nomineeremarks"  onChange={formik.handleChange}  value={formik.values.nomineeremarks}   label={$t('nomineeremarks')} type="text" placeholder={$t('enterNomineeremarks')}        className={inputClassName(formik?.errors?.nomineeremarks)} />
                                                <ErrorMessage name="nomineeremarks" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pancard')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard"  onChange={formik.handleChange}  value={formik.values.pancard}   label={$t('pancard')} type="text" placeholder={$t('enterPancard')}        className={inputClassName(formik?.errors?.pancard)} />
                                                <ErrorMessage name="pancard" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bankname"  onChange={formik.handleChange}  value={formik.values.bankname}   label={$t('bankname')} type="text" placeholder={$t('enterBankname')}        className={inputClassName(formik?.errors?.bankname)} />
                                                <ErrorMessage name="bankname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankacno')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bankacno"  onChange={formik.handleChange}  value={formik.values.bankacno}   label={$t('bankacno')} type="text" placeholder={$t('enterBankacno')}        className={inputClassName(formik?.errors?.bankacno)} />
                                                <ErrorMessage name="bankacno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('passport')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="passport"  onChange={formik.handleChange}  value={formik.values.passport}   label={$t('passport')} type="text" placeholder={$t('enterPassport')}        className={inputClassName(formik?.errors?.passport)} />
                                                <ErrorMessage name="passport" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dateadded')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dateadded" value={formik.values.dateadded} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.dateadded)}        />
                                                <ErrorMessage name="dateadded" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addedbyfk')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addedbyfk"  onChange={formik.handleChange}  value={formik.values.addedbyfk}   label={$t('addedbyfk')} type="text" placeholder={$t('enterAddedbyfk')}        className={inputClassName(formik?.errors?.addedbyfk)} />
                                                <ErrorMessage name="addedbyfk" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('datemodified')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="datemodified" value={formik.values.datemodified} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.datemodified)}        />
                                                <ErrorMessage name="datemodified" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastuserfk')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastuserfk"  onChange={formik.handleChange}  value={formik.values.lastuserfk}   label={$t('lastuserfk')} type="text" placeholder={$t('enterLastuserfk')}        className={inputClassName(formik?.errors?.lastuserfk)} />
                                                <ErrorMessage name="lastuserfk" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
AgentmasterEditPage.defaultProps = {
	primaryKey: 'agentcode',
	pageName: 'agentmaster',
	apiPath: 'agentmaster/edit',
	routeName: 'agentmasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default AgentmasterEditPage;
